import React, { useEffect, useState } from "react";
import Search from "../../../../../../assets/images/inputSearchSuffix.svg";
import ConditionalRender from "../../../../../../reusable-components/ConditionalRender/index";
import {
  getAddMaterialFields,
  testingStatus,
  supplyStatus,
  washedStatus,
  getColumns,
  CONSTANTS_MATERIAL_DATA,
  drawerMaterialHeaderStyles,
  fieldNames,
} from "./constants";
import { InputfieldTypes } from "../../../../../../enums/InputFieldAttributesEnums";
import InputField from "../../../../../../reusable-components/TNInputField";
import styles from "./AddMaterialsForm.module.scss";
import TNButton from "../../../../../../reusable-components/TNButton";
import CreateJobServices from "../../../../../../services/createJob.services";
import {
  ButtonShape,
  ButtonSize,
  ButtonType,
  CommonButtonTexts,
} from "../../../../../../enums/ButtonAttributesEnums";
import { Drawer, Modal, Table } from "antd";
import {
  getMaterialCategoriesDropdownOptions,
  getMaterialNameOptions,
  getMaterialTypeDropdownOptions,
  getQuarrayLocationsDropdownOptions,
} from "../../../../../../utils/getDropdownOptions";
import {
  getMaterialDropdownOptions,
  getSubCategoryDropdownOptions,
  getMaterialIdsByCategory,
  getMaterialIdsBySubCategory,
} from "../../../../../../utils/getDropdownCategories";
import { useFormContext } from "react-hook-form";
import moment from "moment";
import {
  Material,
  MaterialTruck,
  useMaterials,
} from "../../../../../../context/materialListingContext";
import { AddTruckType } from "../../../../../../enums/AddTruckType";
import AddTruckOrdersForm from "../../TruckDetails/AddTruckOrdersForm";
import { PlacementPositions } from "../../../../../../enums/PlacementPositionsEnums";
import TNLoader from "../../../../../../reusable-components/TNLoader";
import {
  AddTruckFormProps,
  BidToolFromKeys,
  SEARCH_FILTER_TYPE,
  truckVendorDetailKeys,
} from "../../TruckDetails/AddTruckOrdersForm/constants";
import { useQueryClient } from "@tanstack/react-query";
import { QuarryData } from "../../../../../../Types";
import { handleMilesFeets } from "./constants";
import TNGoogleAddressSuggestions from "../../../../../../reusable-components/TNGoogleSearch/index";
import { DateFormat } from "../../../../../../enums/dateTimeFormat";
import { dropOffType } from "../../../../../../Types/materialTypes";
import { isEmptyValue } from "../../../../../../utils/emptyStringCheck";

interface AddMaterialFormProps {
  onClose: () => void;
  isEditable?: boolean;
  editData?: MaterialTruck;
  dropOffLatLng?: dropOffType;
}
const AddMaterialForm = ({ onClose, dropOffLatLng }: AddMaterialFormProps) => {
  const queryClient = useQueryClient();
  const {
    WIDTH,
    HEIGHT,
    VENDORS_FOUND,
    NO_VENDORS_FOUND,
    FIND_VENDORS_BTN,
    MODAL: { OK_BUTTON_LABEL, HEADER, CONTENT },
  } = CONSTANTS_MATERIAL_DATA;
  const {
    watch,
    getValues,
    trigger,
    reset,
    setValue,
    resetField,
    clearErrors,
  } = useFormContext();
  const formValues = watch();
  const [pickupCoordValues, setPickUpCoordValues] = useState(null);
  const [dropCoordValues, setDropCoordValues] = useState(null);
  const triggerRequiredFields = () => {
    trigger("quarryName");
    trigger("searchRadius");
    trigger("materialCategories");
    trigger("prickupMaterialAddress");
    trigger("deliveryMaterialAddress");
  };
  const { materialsList, addMaterial } = useMaterials();
  const [isOpen, setIsOpen] = useState(false);
  const [currentVendor, setCurrentVendor] = useState(false);
  const [currentVendorMaterialCost, setCurrentVendorMaterialCost] =
    useState(undefined);
  const [currentVendorMaterialUnit, setCurrentVendorMaterialUnit] =
    useState(undefined);
  const categoriesValue = watch("materialCategories");
  const materialType = watch("materialType");
  const {
    GetDropdownOptions,
    GetQuarryLocations,
    GetTopQuarryLocations,
    FetchDropdownOptions,
    UpdateQuarry,
    UpdateQuarryMaterialTax,
    GetMaterialCategories,
    GetMaterialType,
    GetMaterialName,
  } = CreateJobServices();
  const [keyCount, setKeyCount] = useState(1);
  const [topQuariesFilerData, setTopQuariesFilerData] = useState<QuarryData>(
    []
  );

  const { data: dropdownOptions } = GetDropdownOptions();
  const { data: quarryLocations } = GetQuarryLocations();
  const { data: materialCategoriesData } = GetMaterialCategories({
    quarryId: formValues?.quarryName,
  });
  const { data: materialTypeData } = GetMaterialType({
    quarryId: formValues?.quarryName,
    category: formValues?.materialCategories,
  });
  const { data: materialNameData } = GetMaterialName({
    quarryId: formValues?.quarryName,
    category: formValues?.materialCategories,
    type: formValues?.materialType,
  });
  const {
    mutateAsync: fetchTopQuarryLocations,
    data: topQuarries,
    isPending: isFetchingNearestQuarries,
  } = GetTopQuarryLocations();
  const { mutateAsync: updateQuarry } = UpdateQuarry();
  const { mutateAsync: updateMaterialTax } = UpdateQuarryMaterialTax();
  const categoriesDropdown = getMaterialCategoriesDropdownOptions(
    materialCategoriesData
  );
  const materialTypeDropdownOptions =
    getMaterialTypeDropdownOptions(materialTypeData);
  const materialNameDropdownOptions = getMaterialNameOptions(materialNameData);
  const handleFetchTopQuarryLocations = async () => {
    triggerRequiredFields();
    const materialIdsFilteredOnCategories = getMaterialIdsByCategory(
      dropdownOptions,
      categoriesValue
    );
    const materialIdsFilteredOnType = getMaterialIdsBySubCategory(
      dropdownOptions,
      materialType
    );

    await fetchTopQuarryLocations(
      {
        materialStatus: formValues?.washedStatus,
        materialSupply: formValues?.supply,
        materialTest: formValues?.testingStatus,
        radius: formValues?.searchRadius,
        dropOffLang: dropOffLatLng?.lng,
        dropOffLat: dropOffLatLng?.lat,
        category: formValues?.materialCategories,
        subCategory: formValues?.materialType,
        label: formValues?.materialName,
        quarryId: formValues?.quarryName,
      },
      {
        onSuccess: (data) => {
          setTopQuariesFilerData(data);
        },
      }
    );
  };
  const handleOpenDrawer = () => setIsOpen(true);
  const handleCloseDrawer = () => setIsOpen(false);
  const handleAddVendorModalClose = () => {
    setValue(AddTruckFormProps.TAB_FIELD_NAME, undefined);
    truckVendorDetailKeys.map((item) => setValue(item, undefined));
    truckVendorDetailKeys.map((item) => clearErrors(item));
    BidToolFromKeys.map((item) => setValue(item, undefined));
    BidToolFromKeys.map((item) => clearErrors(item));
    setValue(AddTruckFormProps.REQUIRED_MATERIAL_QUANTITY_NAME, undefined);
    handleCloseDrawer();
  };
  const handleChosenVendor = ({
    key,
    materialCost,
    materialName,
    materialSelected,
    materialPrice,
    truckType,
    truckingCost,
    truckingPrice,
    landedPrice,
    vendor,
    quantity,
    quantityType,
    pickUpLat,
    pickUpLng,
    category,
    subCategory,
    material,
    subShortName,
    materialTax,
  }: Material) => {
    const vendorId = quarryDropdownOptions?.find(
      (item) => item.label === vendor
    );
    const originalQuarry = topQuariesFilerData?.find(
      (quarry) => quarry?.id === vendorId?.value
    );

    // Deep copy using JSON methods
    const updatedQuarry = JSON.parse(JSON.stringify(originalQuarry));

    // Now filter on the copy, not the original
    updatedQuarry.material = updatedQuarry?.material?.filter(
      (material) => material?.id === key
    );

    setCurrentVendor(vendor);
    setCurrentVendorMaterialCost(materialCost.slice(1));
    setCurrentVendorMaterialUnit(quantityType);
    addMaterial({
      materialCost,
      materialName,
      materialSelected: materialSelected,
      materialPrice,
      truckType,
      truckingCost,
      truckingPrice,
      vendor,
      vendorId: vendorId?.value,
      quantity,
      quantityType,
      landedPrice,
      updatedTopQuarriesInfo: updatedQuarry,
      category,
      subCategory,
      material: material,
      subShortName,
      materialTax,
    });
    setPickUpCoordValues(`${pickUpLat},${pickUpLng}`);
    setDropCoordValues(`${dropOffLatLng?.lng},${dropOffLatLng?.lat}`);
    handleOpenDrawer();
    updateQuarry(vendorId?.value);
  };
  const { data: truckOptionsData } = FetchDropdownOptions();
  const trucksTypeObject = truckOptionsData?.find(
    (item) => item.typeofDropDown === "trucksType"
  );
  const truckMaterialTypeObject = truckOptionsData?.find(
    (item) => item.typeofDropDown === "material"
  );
  const quarryDropdownOptions =
    getQuarrayLocationsDropdownOptions(quarryLocations);

  const addMaterialFields = getAddMaterialFields({
    materialCategoriesOptions: categoriesDropdown,
    materialTypeCategoriesOptions: materialTypeDropdownOptions,
    materialNameDropdownOptions: materialNameDropdownOptions,
    quarryDropdownOptions: quarryDropdownOptions,
    testingStatus,
    washedStatus,
    supplyStatus,
  });
  const generateTableData = (data) => {
    return data?.flatMap((entry) =>
      entry?.material?.map((materialItem) => ({
        key: materialItem?.materialId,
        vendorName: entry?.quarryName,
        distanceTime: `${handleMilesFeets(entry?.distance)} ${entry?.duration}`,
        material: materialItem?.label,
        costPerTon: `$${materialItem.price}`,
        quantityType: materialItem?.quantityType,
        materialPrice: materialItem?.price,
        lastUsed:
          entry?.updatedAt !== undefined
            ? moment(entry?.updatedAt).format(DateFormat.MM_DD_YYYY_SLASHED)
            : "",
        pickUpLat: entry?.lng,
        pickUpLng: entry?.lat,
        pickUpAddress: entry?.address,
        materialTax: materialItem?.materialTax,
        quarryId: entry?.id,
        category: materialItem?.category,
        materialLabel: materialItem?.material,
        materialSelected: materialItem?.value,
        subCategory: materialItem?.subCategory,
        subShortName: materialItem?.subShortName,
      }))
    );
  };
  const topQuarriesData = generateTableData(topQuarries);
  const materialCategories = getValues("materialCategories");
  const quarryName = getValues("quarryName");
  const searchRadius = getValues("searchRadius");
  const pickupMaterialAddress = getValues("pickupMaterialAddress");
  const deliveryMaterialAddress = getValues("deliveryMaterialAddress");
  const onChangeHandler =
    (fieldName: string) =>
    (event: React.ChangeEventHandler<HTMLInputElement>) => {
      setValue(fieldName, event);
      if (fieldName === fieldNames.MATERIAL_CATEGORIES) {
        resetField(fieldNames.MATERIAL_TYPE);
        resetField(fieldNames.MATERIAL_NAME);
      } else if (fieldName === fieldNames.MATERIAL_TYPE)
        resetField(fieldNames.MATERIAL_NAME);
      else if (fieldName === fieldNames.QUARRY) {
        resetField(fieldNames.MATERIAL_TYPE);
        resetField(fieldNames.MATERIAL_NAME);
        resetField(fieldNames.MATERIAL_CATEGORIES);
      }
    };

  const [materialTaxPayload, setMaterialTaxPayload] = useState({});
  const handleTaxChange = (record, value) => {
    if (value === "Unknown") {
      setMaterialTaxPayload({});
    } else {
      setMaterialTaxPayload({
        materialId: record?.key,
        quarryId: record?.quarryId,
        materialTax: value,
      });
      openConfirmModal();
    }
  };
  const columns = getColumns({
    handleSelectVendor: handleChosenVendor,
    handleTaxChange: handleTaxChange,
  });

  const [isConfirmMaterialTaxModalOpen, setConfirmMaterialTax] =
    useState(false);
  const [tableKey, setTableKey] = useState(0);

  const openConfirmModal = () => setConfirmMaterialTax(true);
  const closeConfirmModal = () => {
    setConfirmMaterialTax(false);
    setTableKey((prev) => prev + 1);
  };
  const handleModalConfirmation = async () => {
    await updateMaterialTax(
      {
        quarryId: materialTaxPayload?.quarryId,
        materialId: materialTaxPayload?.materialId,
        materialTax: materialTaxPayload?.materialTax,
      },
      {
        onSuccess: async () => {
          closeConfirmModal();
          handleFetchTopQuarryLocations();
        },
      }
    );
  };
  useEffect(() => {
    setKeyCount((prev) => prev + 1);
  }, [isOpen]);
  return (
    <>
      <Modal
        onOk={handleModalConfirmation}
        okText={OK_BUTTON_LABEL}
        title={HEADER}
        visible={isConfirmMaterialTaxModalOpen}
        onCancel={closeConfirmModal}
      >
        {CONTENT}
      </Modal>
      <TNLoader isLoading={isFetchingNearestQuarries} />
      <div className={styles.FieldsContainer}>
        <div className={styles.gridContainer}>
          {addMaterialFields.map((field) => {
            return (
              <>
                <ConditionalRender visible={field.width === "1/3"}>
                  <ConditionalRender
                    visible={field.type === InputfieldTypes.TEXT}
                  >
                    <div className={styles.TopRowContainer}>
                      <InputField
                        className={styles.TextFieldContainer}
                        name={field.name}
                        label={field.label}
                        type={field.type}
                        placeholder={field.placeholder}
                        requiredField={field.required}
                        addonAfter={field.addOnAfter}
                      />
                    </div>
                  </ConditionalRender>
                  <ConditionalRender
                    visible={field.type === InputfieldTypes.GOOGLE}
                  >
                    <div className={styles.EndRowContainer}>
                      <TNGoogleAddressSuggestions
                        name={field.name}
                        placeholder={field.placeholder}
                        label={field.label}
                        type={field.type}
                        suffixContent={<img src={Search} />}
                        requiredField={field.required}
                        isDeliveryMaterialAddress={
                          field.isDeliveryMaterialAddress
                        }
                        isPickupMaterialAddress={field.isPickupMaterialAddress}
                      />
                    </div>
                  </ConditionalRender>
                  <ConditionalRender
                    visible={field.type === InputfieldTypes.SELECT}
                  >
                    <div className={styles.TopRowContainerSelect}>
                      <InputField
                        className={styles.SelectInputField}
                        name={field.name}
                        label={field.label}
                        customSelect={false}
                        placeholder={field.placeholder}
                        type={field.type}
                        requiredField={field.required}
                        disabled={field.disabled}
                        options={field.options}
                        showSearch={true}
                        changeHandler={onChangeHandler(field.name)}
                        optionFilterProp={SEARCH_FILTER_TYPE}
                        allowClear
                      />
                    </div>
                  </ConditionalRender>
                </ConditionalRender>
              </>
            );
          })}
        </div>
        <ConditionalRender visible={topQuarriesData?.length}>
          <div className={styles.VendorsListTableContainer}>
            <h1>
              {topQuarriesData?.length} {VENDORS_FOUND}
            </h1>
            <div className={styles.ApplyChangesButtonContainer}>
              <TNButton
                text="Apply Changes"
                size={ButtonSize.LARGE}
                shape={ButtonShape.DEFAULT}
                type={ButtonType.PRIMARY}
                onClick={handleFetchTopQuarryLocations}
                disabled={!materialCategories || !searchRadius}
              />
            </div>
            <Table
              columns={columns}
              dataSource={topQuarriesData}
              key={[tableKey, topQuarries]}
            />
          </div>
        </ConditionalRender>
        <ConditionalRender
          visible={
            topQuarriesData === undefined || topQuarriesData?.length === 0
          }
        >
          <div className={styles.EmptyVendorsListTableContainer}>
            <ConditionalRender
              visible={
                !!!topQuariesFilerData?.length && topQuarriesData !== undefined
              }
            >
              <h1>{VENDORS_FOUND}</h1>
              <div className={styles.NoVendorMessageContainer}>
                {NO_VENDORS_FOUND}
              </div>
            </ConditionalRender>
          </div>
        </ConditionalRender>
        <Drawer
          key={String(keyCount)}
          visible={isOpen}
          className={styles.AddMaterialForm}
          onClose={handleAddVendorModalClose}
          placement={PlacementPositions.RIGHT}
          width={WIDTH}
          height={HEIGHT}
          title={
            <div className={styles.DrawerHeaderContainer}>{currentVendor}</div>
          }
          headerStyle={drawerMaterialHeaderStyles}
          size={ButtonSize.LARGE}
        >
          <AddTruckOrdersForm
            dropOffMatCoords={dropCoordValues}
            pickupMatCoords={pickupCoordValues}
            topQuariesOuterData={topQuariesFilerData}
            topQuariesMaterialData={topQuarriesData}
            materialDrawerClose={onClose}
            vendorMaterialCost={Number(currentVendorMaterialCost).toFixed(2)}
            venodorMaterialUnit={currentVendorMaterialUnit}
            onClose={handleCloseDrawer}
            materialOptions={truckMaterialTypeObject}
            dropdownData={trucksTypeObject}
            truckFormType={AddTruckType.MATERIAL_VENDOR_FLOW}
          />
        </Drawer>
      </div>
      <div className={styles.ButtonsContainer}>
        <TNButton
          text={CommonButtonTexts.CANCEL}
          shape={ButtonShape.DEFAULT}
          type={ButtonType.DEFAULT}
          size={ButtonSize.LARGE}
          onClick={onClose}
        />
        <TNButton
          text={FIND_VENDORS_BTN}
          shape={ButtonShape.DEFAULT}
          type={ButtonType.PRIMARY}
          size={ButtonSize.LARGE}
          disabled={!materialCategories || !searchRadius}
          onClick={handleFetchTopQuarryLocations}
        />
      </div>
    </>
  );
};

export default AddMaterialForm;
